export default __webpack_public_path__ + "static/media/M Icon.e25bf1c3.svg";